











import {IAsset} from "../../models/shared/asset";
import AtomImage from "../atoms/AtomImage.vue";
import {defineComponent, PropType} from "@vue/composition-api";

export default defineComponent({
  name: "MoleculeCard",
  components: {
    AtomImage
  },
  props: {
    url: {type: String},
    image: {type: Object as PropType<IAsset>}
  }
})
